<template>
  <div class='timeline-wrapper'>
    <app-title title="Timeline"></app-title>
    <app-menu active="timeline"></app-menu>
    <Tweet v-for="(val, index) in tweets" :key="index" :tweet="val" style="margin: 10px auto;">
    </Tweet>
  </div>
</template>

<script>

import axios from 'axios';
import AppMenu from '../../components/Menu.vue'
import AppTitle from '../../components/Title.vue'
import Tweet from '../../components/Tweet.vue'

export default {
  name: 'Timeline',

  components: {
    AppMenu,
    AppTitle,
    Tweet
  },

  data() {
    return {
      tweets: {}
    };
  },

  mounted() {
    axios.get('private/timeline')
    .then((data) => {
      this.tweets = data.data.models.reverse()
    }).catch((err) => {
      console.log(err);
    });
  },

  methods: {
    submitNotice(id, type, index) {
      axios.put(`private/notifications/${id}`,{is_done: 1}
      ).then(data => {
        switch(type) {
          case 0 :
            this.$router.push(`/${this.$store.account.name}`)
            break
          default :
            this.$router.push(this.notifications[index].url)
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
};

</script>

<style scoped>

.timeline-wrapper {
  margin-bottom: 80px;
}
</style>
